import { render, staticRenderFns } from "./periodic-update-view.vue?vue&type=template&id=25006806"
import script from "./periodic-update-view.vue?vue&type=script&lang=js"
export * from "./periodic-update-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports